<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="wednesday">
<h1>Wednesday</h1>
<p>It’s been five Wednesdays since the worst thing happened. People tell me I’m alive.</p>
<p>On days when I can feel the sadness digging its nails in the corners of my eyes, I wonder</p>
<p>if they can see your brown in the shades of my hair,</p>
<p>if they can feel your warmth emanating from my body as they hug me to say hello,</p>
<p>if they can see how you held me</p>
<p>in the way I drag my body around the halls.</p>
<p>With every passing Wednesday, I have learnt that losing you did not kill me,</p>
<p>but no one believes me when I tell them that breathing suffocated by grief</p>
<p>is like no breathing at all.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?e5d9b01c